/**
 * The way to disable bootstrap tab is to add a `.disabled` class to the nav link/nav button
 *
 * Also to prevent fields from disabled tab to be submitted, we have to disable all inputs inside
 * @param {HTMLButtonElement[]|NodeList} navButtons
 */
function updateAddableNavTabsDisability(navButtons) {
	navButtons.forEach((navButton) => {
		const isDisabled = navButton.classList.contains('disabled');
		const contentElement = document.getElementById(navButton.getAttribute('aria-controls'));
		const allInputs = contentElement.querySelectorAll('[name]:not(.input--inactive-by-group)');

		allInputs.forEach((input) => toggleFieldVisibility(input, !isDisabled));
	});
}

/**
 * Event handler for adding new tab
 *
 * We have hardcoded amount of tabs, and we are just enabling/disabling another one
 *
 * Get first disabled tab and enable it
 * @param {MouseEvent} event
 */
function handleAddAddableTab(event) {
	const button = event.target;
	/**
	 * @type {HTMLButtonElement[]} siblings
	 */
	const siblings = [...button.parentNode.children].filter((child) => child !== button);
	const allDisabledSiblings = siblings.filter((sibling) => sibling.classList.contains('disabled'));
	const [firstDisabled] = allDisabledSiblings;
	firstDisabled.classList.remove('disabled');

	updateAddableNavTabsDisability(siblings);
}

/**
 * Event handler for disabling tab
 * @param {MouseEvent} event
 */
function handleRemoveAddableTab(event) {
	event.stopPropagation();
	const closeButton = event.target;
	const button = closeButton.closest('button[role="tab"]');

	// If current tab is active, find first tab, which is not disabled and switch to it
	if (button.classList.contains('active')) {
		let previousButton = button.previousElementSibling;
		while (previousButton.previousElementSibling && previousButton.classList.contains('disabled')) {
			previousButton = previousButton.previousElementSibling;
		}
		$(previousButton).tab('show');
	}

	button.classList.add('disabled');
	updateAddableNavTabsDisability([button]);
}
